// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Steps_stepper__m9rA4","steps":"Steps_steps__LDAkN","step":"Steps_step__7Eeq8","active":"Steps_active__Semt6","badge":"Steps_badge__7uIfD"};